import {RouteDescriptor} from "../../RouteDescriptor";
import {Route} from "../../Route";
import {SubscriptionPage} from "../../../../../pages/Lk/Shared/Subscription/SubscriptionPage";
import {groupApproved, groupNotApproved} from "../../../roles/groups";
import {PageGroupMessages, PageGroups} from "../../pageGroups";
import {defineMessage} from "react-intl";

const SubscriptionRouteTitleMessage = defineMessage({
  id: "subscriptionRoute.title",
  defaultMessage: "Subscription",
})

export const subscription: RouteDescriptor<Route.subscription> = {
  route: Route.subscription,
  render: SubscriptionPage,
  title: SubscriptionRouteTitleMessage,
  path: '/lk/subscription',
  allowRoles: [
    ...groupApproved,
  ],
  redirectToHomeRoles: [
    ...groupNotApproved,
  ],
  showInSidebar: true,
  group: PageGroups.PROFILE,
  groupTitle: PageGroupMessages.profile,
}





